var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 5.52941V8.11765M7.5 5.52941V6.82353M10.1 5.52941V9.41176M2.3 12H12.7C13.0448 12 13.3754 11.8637 13.6192 11.621C13.863 11.3783 14 11.0491 14 10.7059V4.23529C14 3.89207 13.863 3.56291 13.6192 3.32021C13.3754 3.07752 13.0448 2.94118 12.7 2.94118H7.5455C7.33138 2.94007 7.12085 2.88634 6.93261 2.78474C6.74438 2.68315 6.58426 2.53684 6.4665 2.35882L5.9335 1.58235C5.81574 1.40433 5.65562 1.25803 5.46739 1.15643C5.27915 1.05484 5.06862 1.0011 4.8545 1H2.3C1.95522 1 1.62456 1.13634 1.38076 1.37904C1.13696 1.62173 1 1.9509 1 2.29412V10.7059C1 11.4176 1.585 12 2.3 12Z",
    stroke: "#565D6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.646348ac0bfee5a668161e2fea82aed0.svg";
export { ForwardRef as ReactComponent };